export default __webpack_public_path__ + "static/media/shipping_icon.ed67eb36.svg";